import { Component, Input, inject } from "@angular/core";
import { MasterDataService } from "@app/master-data.service";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-refresh-products-hint",
  templateUrl: "./refresh-products-hint.component.html",
  styleUrls: ["./refresh-products-hint.component.scss"],
  imports: [UiKitModule],
  standalone: true,
})
export class RefreshProductsHintComponent {
  private masterDataService = inject(MasterDataService);

  @Input()
  dataType!: string;

  onClickRefresh() {
    this.masterDataService.refresh();
  }
}
